define(function (require) {
    require('Cloud/Application/Fest');
    require('lib/browserFeatures');

    const _ = require('Cloud/Application/_');
    const app = require('Cloud/Application/app');
    const api = require('./Application/api');
    const admitad = require('lib/admitad');
    const params = require('./Application/Params');
    require('./Application/Rubles');

    return function () {
        admitad.saveAdmitadId();

        app.available = function (sid) {
            return this.settings.storages[sid || _.sid()].settings;
        };

        const IS_PHONE = params.getParam('PHONE_BROWSER');
        const IS_PUBLIC = params.getParam('PUBLIC');
        const IS_PUBLIC_FOLDER_PHONE = params.getParam('PUBLIC_FOLDER') && IS_PUBLIC && IS_PHONE;

        // модули, порядок их инициализации играет роль
        const modules = [
            'Ext',
            'Fest',
            'Browser',
            'User',
            'NewUser',
            'Upload.v2',
            'Build',
            'ErrorList',
            'Public',
            'Stock',
            'UrlBuilder',
            'Folder',
            'History',
            'Router',
            'Modifying',
            'Tree',
            'Download',
            'Editor',
            'QueryActions',
            'PromoController',
            'UI',
            'Social',
            'WhatsUp',
            'Counters',
            'Rubles',
            'Window',
            'Payment',
            'Filter',
            'Snackbars',
            'DownloadAsJpeg',
        ];

        modules.forEach(function (module) {
            if (IS_PUBLIC_FOLDER_PHONE && ['Editor'].includes(module)) {
                return;
            }

            module = require(`Cloud/Application/${module}`);

            if (typeof module === 'function') {
                module(app, _);
            } else if (typeof module.default === 'function') {
                module.default(app, _);
            } else {
                Object.assign(app, module);
            }
        });

        const { snackbarController } = require('reactApp/modules/snackbar/snackbar.controller');
        const { SnackbarTypes } = require('reactApp/modules/snackbar/snackbar.types');

        // обработка ошибок
        api.on('api-fail', function (evt, status, error) {
            snackbarController.showSnackbar({
                id: 'error',
                text: 'Ошибка сервера',
                type: SnackbarTypes.failure,
                closable: true,
            });
            RADAR.error(`api-fail_${error}`);
        });

        app.on('page:start', function listener() {
            app.off('page:start', listener);

            if (app.editor) {
                app.editor.clearWindowName(); // CLOUDWEB-6848
            }
        });

        // link for debug
        app._____do_not_use_this_field_in_your_code_it_need_only_for_debug_you_understand_me______ = _;

        return app;
    };
});
